import { Component, Input } from "@angular/core";

export interface DoughnutChartData {
  data: number[];
  labels: string[];
  backgroundColors?: DoughnutChartColors[];
  noData?: boolean;
  loading?: boolean;
  total?: string;
}

interface DoughnutChartColors {
  backgroundColor: string[];
}

@Component({
  selector: "doughnut-chart",
  templateUrl: "./doughnut-chart.component.html",
  styleUrls: ["./doughnut-chart.component.scss"],
})
export class DoughnutChartComponent {
  @Input() cutoutPercentage: number = 85;
  @Input() totalSessions: string;
  @Input() totalLabel: string = "";
  @Input() rateLabel: string = "Rate";
  @Input() customTooltip: boolean = false;
  @Input() tooltipIconMap: { [label: string]: string } = {};
  @Input() chartData: DoughnutChartData = {
    data: [100],
    labels: ["void"],
    backgroundColors: [
      {
        backgroundColor: ["#B1BEC4"],
      },
    ],
  };

  chartOptions = {};

  ngOnChanges(): void {
    const chartData = this.chartData;
    const totalLabel = this.totalLabel;
    const rateLabel = this.rateLabel;
    const customTooltip = this.customTooltip;
    const tooltipIconMap = this.tooltipIconMap;

    let tooltipsConfig: any = {};

    if (customTooltip) {
      tooltipsConfig = {
        enabled: false,
        custom: function(this: any, tooltipModel: any) {
          let tooltipEl = document.getElementById("doughnut-custom-tooltip");
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "doughnut-custom-tooltip";
            document.body.appendChild(tooltipEl);
          }

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = "0";
          } else if (tooltipModel.dataPoints && tooltipModel.dataPoints.length) {
            const index = tooltipModel.dataPoints[0].index;
            const label = chartData.labels[index] || "";
            let colors: string[] = [];
            if (chartData.backgroundColors && chartData.backgroundColors[0]) {
              colors = chartData.backgroundColors[0].backgroundColor;
            }
            const color = colors[index] || "#ccc";
            const sum = chartData.data.reduce((a: number, b: number) => Number(a) + Number(b), 0);
            const value = Number(chartData.data[index]);
            const percentage = sum > 0 ? ((value / sum) * 100).toFixed(1) : "0.0";
            const total = chartData.total || "";

            let totalRow = "";
            if (totalLabel) {
              totalRow = '<div style="font-size:16px;color:#163549;margin-bottom:6px;">' +
                totalLabel + ": <strong style=\"color:#163549;\">" + total + "</strong>" +
              "</div>";
            }
            let titleIcon = "";
            if (tooltipIconMap && tooltipIconMap[label]) {
              titleIcon = '<img src="' + tooltipIconMap[label] + '" style="width:18px;height:18px;flex-shrink:0;" />';
            } else {
              titleIcon = '<span style="width:14px;height:14px;border-radius:50%;background:' + color + ';flex-shrink:0;display:inline-block;"></span>';
            }
            const segmentRateLabel = label ? label + " Rate" : rateLabel;
            tooltipEl.innerHTML =
              '<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;font-size:18px;font-weight:500;color:#163549;">' +
              titleIcon +
              label +
              '</div>' +
              totalRow +
              '<div style="font-size:16px;color:#163549;">' +
              segmentRateLabel +
              ': <strong style="color:#163549;">' +
              percentage +
              '%</strong>' +
              '</div>';

            tooltipEl.setAttribute("style",
              "background:#fff;" +
              "border:1px solid #e6e6e6;" +
              "border-radius:6px;" +
              "box-shadow:0 2px 6px rgba(0,0,0,0.18);" +
              "padding:16px;" +
              "width:262px;" +
              "position:fixed;" +
              "pointer-events:none;" +
              "z-index:9999;" +
              "opacity:1;" +
              "transition:opacity 0.15s;"
            );

            const canvas = this._chart.canvas;
            const rect = canvas.getBoundingClientRect();
            tooltipEl.style.left = (rect.left + tooltipModel.caretX + 12) + "px";
            tooltipEl.style.top = (rect.top + tooltipModel.caretY - 60) + "px";
          }
        },
      };
    }

    this.chartOptions = {
      cutoutPercentage: this.cutoutPercentage,
      legend: {
        display: false,
      },
      tooltips: tooltipsConfig,
      elements: {
        arc: {
          borderWidth: 1.5,
          borderColor: '#ffffff',
          borderRadius: 10,
        },
      },
    };
  }
}
